var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile pt-2" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { md: "auto" } },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://dmp-maps.com/",
                        target: "_blank",
                      },
                    },
                    [
                      _c("b-img", {
                        staticClass: "logo",
                        attrs: { src: _vm.dmpWhiteImg, width: "37%" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-tooltip" },
                    [
                      _c("fa", {
                        staticClass: "info-icon",
                        attrs: { icon: ["fas", "info-circle"] },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "info-tooltip-text" }, [
                        _vm._v(
                          "\n            DMP Map Management Platform\n            "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            Version " +
                            _vm._s(this.version) +
                            "\n            "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            Released " +
                            _vm._s(this.release_date) +
                            "\n            "
                        ),
                        _c("br"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "text-center", attrs: { id: "user_details" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "make-inline-block text-left",
                        staticStyle: { "font-size": "14.5px" },
                      },
                      [
                        _c("span", { staticClass: "pb-3" }, [
                          _vm._v(_vm._s(this.user.name)),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "pb-3" }, [
                          _vm._v(_vm._s(this.user.email)),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "pb-3" }, [
                          _vm._v(_vm._s(this.getFormattedUserRole())),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("br"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "auto" } }, [
                _c(
                  "div",
                  { staticClass: "make-inline-block text-left clickable" },
                  [
                    _c("fa", {
                      class: _vm.showFeatureButtons ? "clicked" : "",
                      attrs: { icon: ["fas", "bars"], title: "Settings" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleFeatureButtons()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "make-inline-block text-left clickable mt-2" },
                  [
                    _c("b-img", {
                      attrs: {
                        src: _vm.logoutImg,
                        width: "20",
                        height: "20",
                        title: "Logout",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.logout()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }